import React, { Component } from 'react';
// import {arrayOf, number, bool, string, func, object} from 'prop-types';
// import { Link } from 'react-router-dom';
import Aux from '../Hoc/Aux';
// import ncqaRating from '../../assets/ncqa-private.png';
import ncqaRatingDual from '../../assets/ncqa-dual.jpg';
import ncqaRatingSingle from '../../assets/ncqa-private.jpg';
// import ncqaMedicaidRating from '../../assets/ncqa-medicaid.png';
import usnews from '../../assets/cdphp-usnews-medicare-2025.svg';
import medicareRating from '../../assets/svg/icon-medicare-rating.svg';
// import medicareRatingPPO from '../../assets/svg/icon-medicare-ppo.svg';
// import medicareRatingHMO from '../../assets/svg/icon-medicare-hmo.svg';
// import medicareRatingDual from '../../assets/svg/icon-medicare-dual-2022.svg';
import jdPowerRating from '../../assets/jdpower-rating-06.png';

class Ratings extends Component {
  render () {
    const dualIcon = {
      width: '298px'
    };
    const medicareIcon = {
      width: '250px'
    };
    const usnewsIcon = {
      width: '122px'
    };

    let ratings;

    if (this.props.medicare === 'true') {
      ratings = (<Aux>
        <div className='col'>
          <span><img src={ncqaRatingSingle} alt='Highest-rated by NCQA' /></span>
          <p>CDPHP Medicare HMO and PPO health plans are among the highest-rated, both in New York State and around the country,&nbsp;by&nbsp;NCQA.* <em>*NCQA Health Plan Ratings 2024</em></p>
        </div>
        <div className='col'>
          <a href='https://www.cdphp.com/-/media/files/medicare/medicare2025/members/medicare-star-rating-ppo-hmo.pdf' target='_blank' rel='noopener noreferrer'>
            <span><img src={medicareRating} alt='4.5 out of 5 Medicare Ranking' style={medicareIcon} /></span>
            <p>Every year, Medicare evaluates plans based on a 5-star rating system.<sup>&dagger;</sup></p>
          </a>
        </div>
        <div className='col'>
          <a href='https://health.usnews.com/medicare/cdphp-medicare-advantage-medicare-plans-in-new-york' target='_blank' rel='noopener noreferrer'>
            <span><img src={usnews} alt='Best Insurance Company for Medicare Advantage 2025 by U.S. News' style={usnewsIcon} /></span>
            <p>Named a Best Insurance Company &ndash; Medicare Advantage 2025 in New York by U.S. News &amp; World&nbsp;Report.</p>
          </a>
        </div>
      </Aux>);
    } else if (this.props.government === 'true') {
      ratings = (<Aux>
        {/* <div className='col'>
          <span><img src={jdPowerRating} alt='8 out of 9 years' style={medicareIcon} /></span>
          <p>#1 in Member Satisfaction among Commercial Health Plans in New York, eight out of nine years.**</p>
        </div> */}
        <div className='col'>
          <span><img src={ncqaRatingSingle} alt='Highest-rated by NCQA' /></span>
          <p>CDPHP health plans are among the highest-rated, both in New York State and around the country, by&nbsp;NCQA.* <em>*NCQA Health Plan Ratings 2024</em></p>
        </div>
        <div className='col'>
          <span><img src={ncqaRatingSingle} alt='Medicare plans are #1 in New York' /></span>
          <p>CDPHP Medicare HMO and PPO health plans are among the highest-rated, both in New York State and around the country, by&nbsp;NCQA.* <em>*NCQA Health Plan Ratings 2024</em></p>
        </div>
      </Aux>);
    } else if (this.props.homepage === 'true') {
      ratings = (<Aux>
        <div className='col'>
          <span><img src={jdPowerRating} alt='8 out of 9 years' style={medicareIcon} /></span>
          <p>#1 in Member Satisfaction among Commercial Health Plans in New York, eight out of nine years.**</p>
        </div>
        <div className='col'>
          <span><img src={ncqaRatingSingle} alt='Highest-rated by NCQA' /></span>
          <p>CDPHP health plans are among the highest-rated, both in New York State and around the country, by&nbsp;NCQA.* <em>*NCQA Health Plan Ratings 2024</em></p>
        </div>
        <div className='col'>
          <a href='https://www.cdphp.com/-/media/files/medicare/medicare2025/members/medicare-star-rating-ppo-hmo.pdf' target='_blank' rel='noopener noreferrer'>
            <span><img src={medicareRating} alt='4.5 out of 5 Medicare Ranking' style={medicareIcon} /></span>
            <p>Every year, Medicare evaluates plans based on a 5-star rating system.<sup>&dagger;</sup></p>
          </a>
        </div>
      </Aux>);
    } else if (this.props.medicaid === 'true') {
      ratings = (<Aux>
        {/* <div className='col w50'>
          <span><img src={jdPowerRating} alt='8 out of 9 years' style={medicareIcon} /></span>
          <p>#1 in Member Satisfaction among Commercial Health Plans in New York, eight out of nine years.**</p>
        </div> */}
        <div className='col w50'>
          <span><img src={ncqaRatingSingle} alt='Medicaid plans are #1 in New York' /></span>
          <p>CDPHP Medicaid plans are among the highest-rated, both in New York State and around the country, by&nbsp;NCQA.* <em>*NCQA Health Plan Ratings 2024</em></p>
        </div>
      </Aux>);
    } else if (this.props.smallbiz === 'true') {
      ratings = (<Aux>
        <div className='col w60'>
          <span><img src={jdPowerRating} alt='8 out of 9 years' style={medicareIcon} /></span>
          <p>CDPHP has been ranked <strong>#1 in Member Satisfaction among Commercial Health Plans in New York</strong> for eight of nine years.**</p>
        </div>
      </Aux>);
    } else {
      ratings = (<Aux>
        <div className='col w50'>
          <span><img src={ncqaRatingDual} alt='Highest-rated by NCQA' style={dualIcon} /></span>
          <p>CDPHP health plans are among the highest-rated, both in New York State and around the country, by NCQA.* <em>*NCQA Health Plan Ratings 2024</em></p>
        </div>
      </Aux>);
    }

    return (
      <section className='divide p60'>
        <div className='wrap three-col ratings'>

          {ratings}

        </div>
      </section>
    );
  }
}

Ratings.propTypes = { // validate props expected
};

export default Ratings;



// WEBPACK FOOTER //
// ./src/components/Ratings/Ratings.jsx